export default "__VITE_ASSET__8ee56d45__"